import { CREATE_UNKNOWN_VEHICLE_LINK_REL } from './constants'

export const createUnknownVehicleLinkSelector = (state) =>
  state.links.filter((link) => link.Rel === CREATE_UNKNOWN_VEHICLE_LINK_REL)[0]
